/*
 * @Descripttion:
 * @version:
 * @Author: gaochen
 * @Date: 2021-09-07 10:19:38
 * @LastEditors: gaochen
 * @LastEditTime: 2021-09-07 11:16:12
 */
const abnormalRouter = [

  {
    path: 'abnormal-profit-details',
    name: 'AbnormalProfitDetails',
    component: () => import('@/views/wxapp/bulletin-board/abnormal/abnormalProfitDetails'),
    meta: {
      title: '净利异常详情'
    }
  }
]
export default abnormalRouter
